import { Grid, Typography } from '@mui/material';
import InfoIcon from 'assets/icons/file-cabinet-trash/info.svg';

export const TrashInfoHeaderCard = () => {
  return (
    <Grid sx={styles.container}>
      <InfoIcon />
      <Typography sx={styles.heading}>
        Items in Trash will be permanently deleted after 30 days.
      </Typography>
      <Typography sx={styles.subheading}>
        You can restore them before that time or delete them permanently at any time.
      </Typography>
    </Grid>
  );
};

const styles = {
  container: {
    width: '100%',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#E9EEFF',
    padding: '14px',
  },
  heading: {
    color: '#4D6EF5',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '146%',
  },
  subheading: {
    color: '#23252F',
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '146%',
  },
};
